module.exports = __webpack_public_path__ + "static/media/IR.4c66c2e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IR.svg
// module id = 280
// module chunks = 0